import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectOneServiceProviderListItems } from "../../../../../redux/one-service-provider/selector";
import { oneServiceProvider } from "../../../../../redux/one-service-provider/action";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";


const ManagementOneServiceProviders = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [pageData, setPageData] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const oneServiceProviderItemsData = useSelector(selectOneServiceProviderListItems);
    const [columnDefs, setColumnDefs] = useState({});

    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(params.node.id, 10) + 1;
                },
            },
            { field: 'AccountId', headerName: 'AccountId',  sortable: true, filter: true,  },

            { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },

            { field: 'UserName', headerName: 'UserName', sortable: true, filter: true, },
        ]);
    };

    const fetchOneServiceProviderList = () => {
        dispatch(oneServiceProvider.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-service-providers/list`,
            entity: 'oneServiceProvider',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc"
            }
        }));
    };

    useEffect(() => {
        createColumnDefs();
        fetchOneServiceProviderList();
    }, [pageData, pageSize]);


    // const handleAdd = () => {
    //     navigate(`${0}`);
    // };



    // const handleDelete = (data: any) => {
    //     dispatch(oneServiceProvider.delete({
    //         url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-service-providers/delete`,
    //         entity: 'oneServiceProvider',
    //         jsonData: {
    //             Records: [
    //                 {
    //                     Id: data?.Id
    //                 }
    //             ]
    //         }
    //     })).then(() => {
    //         fetchOneServiceProviderList();
    //     });
    // };

    const handleEdit = (data: any) => {
        navigate(`${data?.Id}`)
    }
    const handleReloadData = () => {
        fetchOneServiceProviderList()
    }
    const additionButtons: any = [
        // {
        //   svg:
        //     <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
        //       <title>Add One Service Provider</title>
        //       <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        //     </svg>,
        //   callback: () => handleAdd(),
        // },

        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload this table</title>
                    <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            callback: () => handleReloadData(),
        },
    ];

    const handleSearch = (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column,
                FieldText: data?.column,
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "Name",
                FieldText: "Name",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }

        dispatch(oneServiceProvider.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-service-providers/list`,
            entity: 'oneServiceProvider',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
                "Searches": searchCriteria,
            }
        }));
    };



    return (
        <>
            {oneServiceProviderItemsData?.isLoading ?
                <PageLoader /> :
                <Table
                    checkboxConfig={{
                        allowMultiSelect: true,
                        defaultSelectedIds: [],
                        isDisabled: false,
                        keyColumn: 'Id',
                    }}
                    columnData={columnDefs}
                    rowData={oneServiceProviderItemsData?.result?.items}
                    setPageData={setPageData}
                    setPageSize={setPageSize}
                    enableFilter={true}
                    onSearch={handleSearch}
                    paginationData={oneServiceProviderItemsData?.result?.pagination}
                    additionButtons={additionButtons}
                    onEdit={handleEdit}
                    // onDelete={handleDelete}
                    headingName="One Service Providers"
                />
            }
        </>
    );
};

export default ManagementOneServiceProviders;
